const semanticClassNames = {
  root: 'signature-input',
  label: 'signature-input__label',
  button: 'signature-input__button',
  input: 'signature-input__input',
} as const;

export default semanticClassNames;
